import React from 'react';
export function Decorator(_a) {
    var className = _a.className, children = _a.children, id = _a.id, label = _a.label, errorMessage = _a.errorMessage, fieldError = _a.fieldError, hint = _a.hint, fieldset = _a.fieldset, requiredIndicator = _a.requiredIndicator;
    var Wrapper = fieldset ? "fieldset" : "div";
    var Text = fieldset ? "legend" : "label";
    return (React.createElement(Wrapper, { className: className },
        label && React.createElement(Text, { htmlFor: id, className: 'block mb-1.5 text-gray-700 text-sm font-semibold' },
            label,
            " ",
            requiredIndicator && React.createElement("span", { "aria-label": 'Required', className: 'text-primary' }, "*")),
        children,
        (errorMessage || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message))
            ? React.createElement("span", { className: "block mt-1.5 text-error text-sm" }, errorMessage || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message))
            : hint && React.createElement("span", { className: 'block mt-1.5 text-gray-600 text-sm' }, hint)));
}
